import { Tag } from "../types/tag";
import { get, post } from "./fetch.core";

async function listTags() {
  const res = await get<Tag[]>("/admin/tag/list");
  return res.data;
}

async function getTag(id: string) {
  const res = await get<Tag>(`/admin/tag/get?id=${id}`);
  return res.data;
}

async function deleteTag(id: string) {
  const res = await post(`/admin/tag/delete`, { id });
  return res.data;
}

async function enableTag(data: any) {
  const res = await post(`/admin/tag/setEnable`, { data });
  return res.data;
}

async function unTag(productId: string, tagId: string) {
  const res = await post("/admin/tag/untag", { productId, tagId });
  return res.data;
}

const obj = {
  listTags,
  getTag,
  deleteTag,
  enableTag,
  unTag,
};

export default obj;
